// extracted by css-extract-rspack-plugin
export default {"bulkAction":"FwG92pOMdVgWPNJn"};